import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';

interface AuthLayoutProps {
    title: string;
    subtitle?: string;
    children: ReactNode;
    footer?: ReactNode;
}

export function AuthLayout({ title, subtitle, children, footer }: AuthLayoutProps) {
    return (
        <div className="auth-page">
            <div className="auth-card">
                <Link to="/" className="auth-brand" aria-label="Quotio">
                    <img src="/logoQuotio.png" alt="Quotio" />
                </Link>

                <div className="auth-head">
                    <h1 className="auth-title">{title}</h1>
                    {subtitle && <p className="auth-subtitle">{subtitle}</p>}
                </div>

                {children}

                {footer && <div className="auth-footer">{footer}</div>}
            </div>

            <p className="auth-backhome">
                <a href="/">← Retour au site</a>
            </p>

            <nav className="auth-legal" aria-label="Informations légales">
                <a href="/conditions-utilisation.html">Conditions d'utilisation</a>
                <span aria-hidden="true">·</span>
                <a href="/politique-confidentialite.html">Confidentialité</a>
                <span aria-hidden="true">·</span>
                <a href="/cookies.html">Cookies</a>
                <span aria-hidden="true">·</span>
                <a href="/mentions-legales.html">Mentions légales</a>
            </nav>
        </div>
    );
}
